import { useMutation } from "@apollo/client/react";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import TimeZone from "utils/TimeZone";
import Uuid from "utils/Uuid";
import { ScheduleDowntimeBlock } from "./downtimeBlock.gql";
import { insertDowntimeBlock } from "./helpers/handleUpdateDowntimeBlocks";

export default function useScheduleDowntimeBlock() {
  const { setNotification } = useNotificationState();
  const [scheduleDowntimeBlock] = useMutation(ScheduleDowntimeBlock, {
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to schedule downtime block",
          type: "danger",
        });
      });
    },
  });

  const applicationContext = useApplicationContext();

  return (downtimeBlock) => {
    const { reason, startsAt: rawStartsAt, endsAt: rawEndsAt, line, lockedOnSchedule, reasonCode } = downtimeBlock;
    const id = Uuid.generate();

    return scheduleDowntimeBlock({
      optimisticResponse: {
        scheduleDowntimeBlock: {
          __typename: "ScheduleDowntimeBlockPayload",
          downtimeBlock: { ...downtimeBlock, id },
        },
      },
      update: (proxy, { data }) => {
        const newDowntimeBlock = data.scheduleDowntimeBlock.downtimeBlock;

        insertDowntimeBlock(newDowntimeBlock, proxy);
      },
      variables: {
        endsAt: TimeZone.overrideZone(rawEndsAt, applicationContext.timeZone.name),
        id,
        lineId: line.id,
        lockedOnSchedule,
        reason,
        reasonCode,
        startsAt: TimeZone.overrideZone(rawStartsAt, applicationContext.timeZone.name),
      },
    });
  };
}
